import { render, staticRenderFns } from "./toast-container.vue?vue&type=template&id=bbbe4c4a"
import script from "./toast-container.vue?vue&type=script&lang=js"
export * from "./toast-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports